import { adminNavItems } from '../admin/adminNav';

/** Map admin paths to blockable page ids (nav id, with unshipped special-case). */
const PATH_TO_PAGE_ID = {
  '/admin/dashboard': 'dashboard',
  '/admin/search': 'search',
  '/admin/products': 'products',
  '/admin/upload-tracking': 'upload-tracking',
  '/admin/revenue-calculator': 'revenue-calculator',
  '/admin/analytics': 'analytics',
  '/admin/orders': 'orders',
  '/admin/unshipped-orders': 'unshipped-orders',
  '/admin/procurement': 'procurement',
  '/admin/customer-service': 'customer-service',
  '/admin/inventory': 'inventory',
  '/admin/invoices': 'invoices',
  '/admin/reports': 'reports',
  '/admin/fulfillment': 'fulfillment',
};

export function resolveBlockedPageId(pathname) {
  for (const [path, id] of Object.entries(PATH_TO_PAGE_ID)) {
    if (pathname === path || pathname.startsWith(`${path}/`)) {
      return id;
    }
  }
  return null;
}

export function isAdminPathBlocked(pathname, blockedPages = []) {
  if (!blockedPages?.length) {
    return false;
  }

  const pageId = resolveBlockedPageId(pathname);
  return Boolean(pageId && blockedPages.includes(pageId));
}

export function getBlockedPageLabel(pathname) {
  const pageId = resolveBlockedPageId(pathname);
  if (!pageId) {
    return 'This page';
  }

  const nav = adminNavItems.find((item) => {
    if (pageId === 'dashboard') return item.id === 'home';
    if (pageId === 'unshipped-orders') return item.id === 'unshipped';
    return item.id === pageId;
  });

  return nav?.label || 'This page';
}
